import { render, staticRenderFns } from "./add_group.vue?vue&type=template&id=751f38c4&scoped=true"
import script from "./add_group.vue?vue&type=script&lang=js"
export * from "./add_group.vue?vue&type=script&lang=js"
import style0 from "./add_group.vue?vue&type=style&index=0&id=751f38c4&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "751f38c4",
  null
  
)

export default component.exports